<template>
  <div class="openid-manage">
    <a-table :columns="columns" :data-source="dataSource" :loading="loading" :rowKey="record => record.id">
      <template slot="type" slot-scope="type">{{ type | typeFormat}}</template>

      <span slot="action" slot-scope="text, record">
        <a-button size="small" @click="clickModify(record.openId)" style="margin-right:8px;">修改</a-button>
        <a-button type="danger" size="small" @click="clickDelete(record.id)">删除</a-button>
      </span>
    </a-table>
  </div>
</template>

<script>
import { getOpenidList, deleteOpenid } from '@/api/api'

const columns = [
  // {
  //   title: 'id',
  //   dataIndex: 'id'
  // },
  {
    title: 'openid',
    dataIndex: 'openId'
  },
  {
    title: '分组',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'openid-manage',

  data() {
    return {
      loading: false,
      columns,
      dataSource: []
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      getOpenidList()
        .then(res => {
          if (res.error.code === 0) {
            this.dataSource = res.response.dataList
          } else {
            this.dataSource = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    clickDelete(id) {
      this.$confirm({
        title: '确定删除吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          deleteOpenid(id).then(res => {
            if (res.error.code === 0) {
              this.$message.success('删除成功')
              this.fetchData()
            }
          })
        }
      })
    },

    clickModify(openId) {
      this.$router.push({
        name: 'openid-modify',
        params: {
          openId
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.openid-manage {
  background-color: white;
  padding: 24px;
}
</style>
